module.exports = __webpack_public_path__ + "static/media/MotionBuilder.bd8d5b76.png";